import React, { useEffect } from "react";
/* import { useLocation, useNavigate } from "react-router-dom"; // Import useNavigate hook
import { getGallery } from "../Service/Api"; */
import Header from '../Component/Header'
import { Link } from 'react-router-dom'
import LazyLoad from "react-lazyload";
import Footer from'../Component/Footer'
const AluminiAssociation = () => {
     useEffect(() => {
        document.title = 'Alumini Association -  St Peters convent School Faridabad Haryana';  
    }, []); 
/*     const navigate = useNavigate();
    const location = useLocation(); 
    const [data, setData] = useState("");
    const [index, setIndex] = React.useState(-1);
   
  
    useEffect(() => {
      const getData = async () => {
        try {
          let subgalleryData = await getGallery();
        
          setData(subgalleryData);
        } catch (error) {
          console.log(error);
        }
      };
      getData();
    }, []);
   
  
    const slides = data?.attachments?.map(img => ({
      src: `https://webapi.entab.info/api/image/${img}`
    })); */
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  Alumini    </li> 
     <li>Alumini Association </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Alumini Association  </h1>
         </div>
     </div>
      {  /*  <div className="row">
     <div className="col-md-12">
         <p>{data.description}</p>
     </div>
     {data !== "" &&
     data?.attachments.map((img,index) => (
            <div className=" col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount"> 
                <a data-magnify="gallery" data-src="" data-group="a" href={`https://webapi.entab.info/api/image/${img}`} onClick={() => setIndex(index)}><LazyLoad><img src={`https://webapi.entab.info/api/image/${img}`} onClick={() => setIndex(index)} className=" img-fluid" alt="STPSCH" /></LazyLoad></a> 
            </div> 
            ))} 
            </div> */}

            <div className="row">
            <div className="col-md-12">
                <p>"The sweetness of reunion is the joy of heaven."   <br/> 
                    We were pleased to host the batch of 2020 - 𝟐𝟎23 celebrated their 𝐀𝐥𝐮𝐦𝐧𝐢 𝐑𝐞𝐮𝐧𝐢𝐨𝐧.<br/> 
                    Thank you to everyone who came and enjoyed the Alumni Reunion - we loved seeing everyone back together again! It created so much nostalgia and memories. Do get in touch with us... </p>
            </div>
            <div className=" col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount"> 
            <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Alumini1.jpg"><LazyLoad><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Alumini1.jpg" className=" img-fluid" alt="STPSCH" /></LazyLoad></a> 
            </div> 
            <div className=" col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount"> 
            <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Alumini2.jpg"><LazyLoad><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Alumini2.jpg" className=" img-fluid" alt="STPSCH" /></LazyLoad></a> 
            </div> 
            <div className=" col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount"> 
            <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Alumini3.jpg"><LazyLoad><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Alumini3.jpg" className=" img-fluid" alt="STPSCH" /></LazyLoad></a> 
            </div> 
            <div className=" col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount"> 
            <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Alumini4.jpg"><LazyLoad><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Alumini4.jpg" className=" img-fluid" alt="STPSCH" /></LazyLoad></a> 
            </div> 
            <div className=" col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount"> 
            <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Alumini5.jpg"><LazyLoad><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Alumini5.jpg" className=" img-fluid" alt="STPSCH" /></LazyLoad></a> 
            </div> 
            <div className=" col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount"> 
            <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Alumini6.jpg"><LazyLoad><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Alumini6.jpg" className=" img-fluid" alt="STPSCH" /></LazyLoad></a> 
            </div> 
            <div className=" col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount"> 
            <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Alumini7.jpg"><LazyLoad><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Alumini7.jpg" className=" img-fluid" alt="STPSCH" /></LazyLoad></a> 
            </div> 
            <div className=" col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount"> 
            <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/STPSFH/public/Images/Alumini8.jpg"><LazyLoad><img src="https://webapi.entab.info/api/image/STPSFH/public/Images/Alumini8.jpg" className=" img-fluid" alt="STPSCH" /></LazyLoad></a> 
            </div>  
            </div>
     </div>
   </div>
<Footer/>
    </>
  )
}

export default AluminiAssociation
